/** The effects whose art is a manoeuvre diagram drawn on nothing, which
 * wants a floor behind it to read. */
const DIAGRAMS = new Set([
  'backfire', 'bootlegger', 'drift', 'emergencyBrake', 'enhancedSteering', 'fishtail',
  'hardTurn', 'jTurn', 'jink', 'kTurn', 'pitMove', 'pivot', 'scandinavianFlick',
  'serpentine', 'shunt', 'skid', 'slingshot', 'spinOut', 'sweeper', 'swerve', 'yTurn',
]);

/** An Option card's art, by effect, so a turn card shows its original's.
 * Where there is none it is hidden, or blank if `keepSpace`. */
export function OptionIcon({ effect, keepSpace }: { effect: string; keepSpace?: boolean }) {
  return (
    <img
      className={`option-icon${DIAGRAMS.has(effect) ? ' option-diagram' : ''}`}
      src={`/options/${effect}.png`}
      alt=""
      onError={(e) => {
        if (keepSpace) e.currentTarget.style.visibility = 'hidden';
        else e.currentTarget.style.display = 'none';
      }}
    />
  );
}
